import { ContainerType } from '@types-internal';

import DeleteAllCardsModal from './Modals/DeleteAllCardsModal/DeleteAllCardsModal';
import DeleteCardModal from './Modals/DeleteCardModal/DeleteCardModal';
import DeleteCardModalNew from './Modals/DeleteCardModalNew/DeleteCardModalNew';
import NewCardModal from './Modals/NewCardModal/NewCardModal';

type OverlaysProps = {
  containerType: ContainerType;
  customerType?: string;
  currency?: string;
  customerId?: string;
  sid?: string;
  siteId?: number;
};

const Overlays: React.FC<OverlaysProps> = ({
  containerType,
  customerType,
  currency,
  customerId,
  sid,
  siteId,
}) => {
  return (
    <>
      <NewCardModal
        containerType={containerType}
        customerType={customerType}
        currency={currency}
        customerId={customerId}
        sid={sid}
        siteId={siteId}
      />
      <DeleteAllCardsModal />
      <DeleteCardModal />
      <DeleteCardModalNew />
    </>
  );
};

export default Overlays;
